import { useState, useEffect } from 'react'
import { Meta, WappInput, WappMode } from '@weblite-wapps/protocol'
import {
  useNavigate,
  getPanelHistory,
  useHistoryCustomBack,
  getSectionsHistory,
  getSectionsHistoryTop,
} from 'weblite-router'
import { WapprunnerCreate } from 'weblite-web-wapprunner'
import { VisibilityHandler } from './components/visibility-handler'
import { hideVitrine } from '$logic/router'
import { isDesktopSize } from '$func/environmentInfo.js'

export interface VitrineInput {
  channelId?: string
  hasEditAccess?: boolean
  isSubscriber?: boolean
}

export const vitrineAPI = {
  setInput(_input: VitrineInput) {},
  setWappMeta(_meta: Meta) {},
}

export function Vitrine() {
  const [wappMeta, setWappMeta] = useState<Meta | null>(null)
  const [input, setInput] = useState<VitrineInput>({})

  let isTop: boolean
  if (isDesktopSize()) {
    const activeSections = getSectionsHistory()
    const rightPartTopSection = activeSections.reduce(
      (acc, section) =>
        ['left', 'channelVitrine'].includes(section) ? section : acc,
      '',
    )

    isTop = rightPartTopSection === 'channelVitrine'
  } else isTop = getSectionsHistoryTop() === 'channelVitrine'

  const [delayedIsTop, setDelayedIsTop] = useState(isTop)

  useEffect(() => {
    if (isTop) {
      setDelayedIsTop(true)
      return
    }

    let timeout: NodeJS.Timer

    // TODO[router]: Refactor
    if (isDesktopSize()) setDelayedIsTop(false)
    timeout = setTimeout(() => setDelayedIsTop(false), 500)

    return () => {
      if (timeout) clearTimeout(timeout)
    }
  }, [isTop])

  useEffect(() => {
    vitrineAPI.setInput = setInput
    vitrineAPI.setWappMeta = setWappMeta
  }, [])

  const navigate = useNavigate()
  useHistoryCustomBack(
    () => {
      const history = getPanelHistory('vitrine')
      const [panelTop] = history.slice(-1)

      if (history.length === 1 || panelTop === 'INIT') hideVitrine()
      else navigate(-1)
    },
    [],
    isTop,
  )

  if (!wappMeta?.wappSessionId) return null

  const { wappSessionId } = wappMeta
  const { channelId } = input

  return (
    <VisibilityHandler zIndex={1} freezeChildren={!delayedIsTop}>
      <div style={{ width: '100%', height: '100%', backgroundColor: 'white' }}>
        <WapprunnerCreate
          key={`${channelId}-${wappMeta.wappId}`}
          wappSessionId={wappSessionId}
          wappId={wappMeta.wappId}
          mode={WappMode.STATIC}
          input={input as WappInput}
        />
      </div>
    </VisibilityHandler>
  )
}
